<template>
    <v-hover v-slot="{ hover }">
        <v-card :elevation="hover ? 4 : 2">
        <v-card-title>
            <v-col cols="12" sm="12" md="8" xl="4">
            <div :class="`${arabic?'arFont':'enFont'} avatar`">
            <v-avatar color="primary" size="40">
                <span class="white--text text-">{{getInitials(item.account.name)}}</span>
            </v-avatar>
            <span class="account-name mx-2">{{ item.account.name }}</span>
            </div>
            </v-col>

            <v-col cols="12" sm="12" md="6" xl="4">
            <span color="primary" :class="`${arabic?'arFont':'enFont'} pr-3`">
                <span class="grey--text mx-2 text-label">{{ i18n["total_orders"] }}:</span>
                <span class="black--text text-value" >{{ item.count }}</span>
            </span>
            </v-col>

            <v-col cols="12" sm="12" md="6" xl="4">
            <span color="primary" :class="`${arabic?'arFont':'enFont'} pr-3`">
                <span class="grey--text  text-label mx-2"> {{ i18n["percentage_from_total_orders"] }}:</span>
                <span class="black--text text-value">{{ `%${item.percentage}` }}</span>
            </span>
            </v-col>
        </v-card-title>
        </v-card>
    </v-hover>
</template>

<script>
import languageMixins from '@/mixings/language';

export default {
  mixins: [languageMixins],

  props: ['item'],

  methods: {
    getInitials(name = '') {
      return name.split(' ').map((n) => n[0]).slice(0, 2).join('');
    },
  },
  computed: {
        api() {
            return this.$store.state.settings.apiBase
        },
        language() {
            return this.$store.state.language
        },
        i18n() {
            return this.$store.state.i18n[this.$store.state.language]
        },
        arabic() {
            if (this.$store.state.language == 'ar') return true
        },
    },
};
</script>

<style>
.avatar {
    border-radius: 28px;
    border: 1px solid #a4a3a3;
    padding: 5px;
}
.account-name {
    font-size: 14px;
    font-weight: 500;
}
.text-label {
    font-size: 13px;
    font-weight: bold;
}
.text-value {
    font-size: 15px;
}
</style>
